import { configureStore } from '@reduxjs/toolkit';
import pageSlice from '../features/page/PageSlice';

export default configureStore({
  reducer: {
    page: pageSlice,
  },
})